 
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetLanguagesDocument = gql`
    query GetLanguages($menuId: Int, $branchId: Int!, $typeMenu: MenuTypeType) {
  menu(menuId: $menuId, branchId: $branchId, type: $typeMenu) {
    id
    branch {
      id
    }
    languages {
      id
      name
      isoCode
    }
    primaryLanguage {
      id
      name
      isoCode
    }
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      branchId: // value for 'branchId'
 *      typeMenu: // value for 'typeMenu'
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables> & ({ variables: GetLanguagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export type GetLanguagesQueryVariables = Types.Exact<{
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
}>;


export type GetLanguagesQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', id: number, branch: { __typename?: 'BranchProxy', id: number }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null } };
